import Store from "../store";
var _AssetManagerBridge = {
    requestClaim: function() {
    //We dont have claim & release in frontend
    },
    releaseClaim: function() {},
    indexClaims: function(transactionId, publish) {
        var options = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
        setTimeout(function() {
            var state = Store.getState();
            var claims = state.claims[options.chartId || state.currentSlide];
            publish("index", claims);
        }, 0);
    }
};
export var AssetManagerBridge = _AssetManagerBridge;
